export enum CollectionsSubRoutesEnum {
  COLLECTION_ID = 'id',
  TAG_ID = 'tag',
  LIST = 'list/:' + COLLECTION_ID,
  LISTS = 'lists',
  TAGS = 'tags/:tag-type',
  MY_LISTS = 'my-lists',
  FOLLOWED_LISTS = 'followed-lists',
  WISHLIST = 'wishlist',
  WATCHED = 'seen',
  HASHTAG = 'hashtag',
  FOLLOWERS_USERS = 'followers-users',
  FOLLOWING_USERS = 'following-users',
  STREAMING = 'streaming-platforms'
}

export enum CollectionRoutesEnum {
  TAG_ID = 'tag',
  USER_ID = 'username',
  TAG_TYPE_ID = 'tag-type',
  LIST_ID = 'id',

  COLLECTION_LIST = CollectionsSubRoutesEnum.LIST,
  COLLECTION_LISTS = 'lists',
  COLLECTION_FOLLOWED_LISTS = 'collections/' + CollectionsSubRoutesEnum.WISHLIST,
  COLLECTION_STREAMING = CollectionsSubRoutesEnum.STREAMING,
  COLLECTION_TAGS_IN_TAGTYPE = CollectionsSubRoutesEnum.TAGS,
  COLLECTION_USERS = 'users',

  MY_ACTIVITY_WISHLIST = 'my-activity/:' + USER_ID + '/' + CollectionsSubRoutesEnum.WISHLIST,
  MY_ACTIVITY_SEEN = 'my-activity/:' + USER_ID + '/' + CollectionsSubRoutesEnum.WATCHED,
  MY_ACTIVITY_TAGS = 'my-activity/:' + USER_ID + '/tags/:' + TAG_TYPE_ID,
  MY_ACTIVITY_STREAMING_PLATFORMS = 'my-activity/:' + USER_ID + '/' + CollectionsSubRoutesEnum.STREAMING,
  MY_ACTIVITY_LISTS = 'my-activity/:' + USER_ID + '/lists',
  MY_ACTIVITY_FOLLOWED_LISTS = 'my-activity/:' + USER_ID + '/followed-lists',
  MY_ACTIVITY_LIST = COLLECTION_LIST,

  USER_ACTIVITY = 'user-activity/:' + USER_ID,
  USER_ACTIVITY_SAVED = 'user-activity/:' + USER_ID + '/saved',
  USER_ACTIVITY_SEEN = 'user-activity/:' + USER_ID + '/seen',
  USER_ACTIVITY_RATED = 'user-activity/:' + USER_ID + '/rated',
  USER_ACTIVITY_MY_LISTS = 'user-activity/:' + USER_ID + '/lists',
  USER_ACTIVITY_FOLLOWING = 'user-activity/:' + USER_ID + '/following',
  USER_ACTIVITY_FOLLOWERS = 'user-activity/:' + USER_ID + '/followers'
}
